import React from 'react';

import { useAccounts, useAppSelector, useAuthentication } from '@pkg/hooks';

import { EmptyState } from '@app/pages/ProfilePage/components';
import { useIsPreview } from '@app/pages/ProfilePage/hooks';
import { useWalletStore } from '@app/store/zustand';

function EmptyText() {
    const isPreview = useIsPreview();
    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);

    const { connectedWallets: wallets } = useAccounts();

    const { protectedAction } = useAuthentication();
    const { toggleShowOverview } = useWalletStore();

    function handleOpenWalletManager() {
        protectedAction(() => {
            toggleShowOverview(true);
        });
    }

    const emptyText = {
        title: 'It’s lookin’ a little empty in here 👀',
        text: isPageOwner && !isPreview ? 'Looks like you haven’t connected any wallets.' : undefined,
        buttonText: isPageOwner && !isPreview ? 'Connect a wallet' : undefined,
    };

    if (wallets && wallets?.length > 0) {
        emptyText.text =
            isPageOwner && !isPreview
                ? 'It may take some time for your NFTs to load. Please wait or try connecting another wallet.'
                : undefined;

        emptyText.buttonText = isPageOwner && !isPreview ? 'Connect another wallet' : undefined;
    }

    return <EmptyState onClick={handleOpenWalletManager} {...emptyText} />;
}

export default EmptyText;
